/** How each catalogue value reads on the page (Phase 4 design D2; the catalogue is the server's). */
const LABELS: Record<string, string> = {
  AirConditioning: "Air conditioned",
  WiFi: "Wi-Fi",
  Parking: "Parking",
  WheelchairAccess: "Wheelchair access",
  KidsFriendly: "Kid friendly",
  BeverageService: "Drinks served",
  PrivateRoom: "Private room",
  Cash: "Cash",
  Card: "Card",
  Upi: "UPI",
  Wallet: "Wallet",
};

/** A value this build has no label for still shows, split at its capitals. */
export function amenityLabel(value: string): string {
  return LABELS[value] ?? value.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
}
